import $ from "jquery";
import { isNullOrUndefined } from 'util';
import withCart from '../General/withCart';
import { AbconetApi } from '../General/AbconetApi';
import { ProductPrice } from './ProductPrice';
import { ProductApprovedStockListLogo } from './ProductApprovedStockListLogo';

import { InStockContainer, InStockState } from './InStock';
import { OutOfStock } from './OutOfStock';
import { isOutOfStock } from "../General/Helper";

import { QuantitySelector } from "../General/QuantitySelector";
import { getStock } from "../Cart/CartFunctions";

class ProductRowRaw extends React.Component {

    constructor(props) {
        super(props);
        var amount = "";
        var inCurrentOrder = false;
        var cartItem = this.getCartItem();
        if (cartItem) {
            amount = cartItem.quantity;
            inCurrentOrder = true;
            
        }

        this.state = {
            cartItem: cartItem,
            amount: amount,
            inCurrentOrder: inCurrentOrder,
            isSaving: false,
            isSynced: true,
            showAlternatives: false,
            stock: null,
            minimumQuantity: null,
        }
    }

    componentDidUpdate(prevProps) {
        if (this.getCartItem() && this.state.amount !== this.getCartItem().quantity && this.state.isSynced === true) {
            this.setState({
                amount: this.getCartItem().quantity,
                inCurrentOrder: true,
                cartItem: this.getCartItem()
            });
           
        }
    }

    componentDidMount() {
        setTimeout(() => {
            let stockSpecialOrder;
            if (this.props.cart && this.props.item.stockAvailability) {
                stockSpecialOrder = getStock(this.props.cart, this.props.item.stockAvailability);
            }

            this.setState({
                open: true,
                minimumQuantity: stockSpecialOrder && stockSpecialOrder.minimumQuantity
            });

        }, 300)
    }

    addToTracking() {
        console.log('Added', this.props);
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
            event: "add_to_cart",
            ecommerce: {
                currency: "AUD",
                value: this.props.item.bestPrice,
                items: [
                    {
                        item_id: this.props.item.stockcode,
                        item_name: this.props.item.name,
                        quantity: this.state.amount,
                        price: this.props.item.bestPrice
                    }
                ]
            }
        });
       
    }

    updateCart(ev) {
        this.addToTracking();
        ev.preventDefault();

        var self = this;
        this.setState({ isSaving: true });
        AbconetApi.post(`/api/cart/stockcode/${this.props.item.stockcode}`, this.state.amount).then(function (cart) {
            $(document).trigger("CartUpdated", cart);
            self.setState({
                isSynced: true,
                inCurrentOrder: true,
                isSaving: false
            });
        });
    }

    getCartItem() {
        if (this.props.cart) {
            for (var i = 0; i < this.props.cart.lines.length; i++) {
                var cartRow = this.props.cart.lines[i];
                if (cartRow.stockcode === this.props.item.stockcode) {
                    return cartRow;
                }
            }
        }
    }

    getSupplyLocation() {
        var supplyLocation = '';
        if (this.props.cart) {
            supplyLocation = this.props.cart.supplyLocation;
        }

        return supplyLocation;
    }

    updateAmount(ev) {
        var newAmount = ev.target.value;

        if (newAmount < 0) {
            this.setState({
                amount: 0,
                isSynced: false
            });
        } else {
            this.setState({
                amount: newAmount,
                isSynced: false
            });
        }
    }


    renderInStock() {
        if (this.props.showFullStockInfo && this.props.item.stockAvailability != null) {
            return <InStockContainer stockAvailability={this.props.item.stockAvailability} />;
        }

        if (isNullOrUndefined(this.props.cart) || isNullOrUndefined(this.props.cart.supplyLocation) || this.props.cart.supplyLocation == '' ) {
            return null;
        }

        if (this.props.cart && this.props.item.stockAvailability) {
            var currentLocation = this.props.item.stockAvailability.filter((location) => {
                return this.props.cart.supplyLocation == location.locationName;
            });

            if (isNullOrUndefined(currentLocation[0]) || isNullOrUndefined(currentLocation[0].status)) {
                return;
            }
           
            return <InStockState stockAvailability={currentLocation[0]} hideInStock hideState />;
        }
    }

    renderAddToOrderButton() {
        var btnClass = 'changes';
        var disabled = false;

        var buttonText = "Add to order";
        if (this.state.inCurrentOrder) {
            buttonText = "Update";
        }

        if (this.state.isSaving) {
            disabled = true;
            buttonText = "Updating";
            btnClass = 'saving';
        }

       
        if (!this.state.amount || this.state.isSynced || (this.state.minimumQuantity && this.state.minimumQuantity > this.state.amount) ) {
            disabled = true;
        }

        return <button href="#" className={"btn btn-primary add-to-order" + btnClass} disabled={disabled} onClick={this.updateCart.bind(this)}>{buttonText}</button>;
    }

    renderEditCartOptions() {
        if (this.props.limitOrderToApprovedStocklist && this.props.item.isApprovedStocklist == false) {
            return;
        }

        if (this.props.limitOrderToTemplateStocklist && this.props.item.isTemplateStocklist == false) {
            return;
        }
  
        if ((isOutOfStock(this.getSupplyLocation(), this.props.item) && this.props.item.cannotBeBackordered)) {
            return <div className="col-3">
                <OutOfStock product={this.props.item} supplyLocation={this.getSupplyLocation()} />
            </div>;
        }

        return [
            <div key={"addToCartContainer"} className="col col-md-4 col-sm-4 add-to-cart-container">
                <QuantitySelector
                    cart={this.props.cart}
                    item={this.props.item}
                    onChange={this.updateAmount.bind(this)}
                    value={this.state.amount}
                    unit={this.props.item.unit}
                    unitPlural={this.props.item.unitPlural}
                    packQty={this.props.item.packQty}
                    palletQty={this.props.item.palletQty}
                    layerQty={this.props.item.layerQty} />

            </div>,
            <div key={"actionsContainer"} className="actions-container">
                <div className="actions">
                    {/*<a href="#" className="add-favourite">Add to favourites</a> TODO: Add favourite functionality*/}
                    {this.renderAddToOrderButton()}
                    
                </div>
            </div>
        ];
    }

    renderPrice() {
        if (this.props.item.bestPrice > 0) {
            return <div className="col-5 col-md-3 col-sm-3 price-container">
                <ProductPrice product={this.props.item}/>
            </div>;
        }
    }

    renderShowAlternativesButton() {
        if (this.props.item.alternativeProductCollection.length == 0) {
            return null;
        }

        if (this.props.disableItemReplacement == true) {
            return null;
        }

        if (this.state.showAlternatives) {
            return null;
        }

        return <button className="btn-show-alternatives btn btn-link btn-sm alternate-btn" onClick={() => { this.setState({ showAlternatives: true });}}>Show Alternatives</button>;
    }

    renderShowAlternatives() {
        if (!this.state.showAlternatives) {
            return <div className="alt-stock"></div>;
        }
        
        return <div className="alt-stock open">
            <button className="close" onClick={() => { this.setState({ showAlternatives: false }); }}><i className="icon icon-dropdown-arrow"/></button>
                {this.props.item.alternativeProductCollection.map((item) => {
                    return <ProductRow
                        key={"item-row-" + item.stockcode}
                        item={item}
                        canAddToCart={this.props.canAddToCart}
                        limitOrderToApprovedStocklist={this.props.limitOrderToApprovedStocklist}
                        limitOrderToTemplateStocklist={this.props.limitOrderToTemplateStocklist}
                        showFullStockInfo={this.props.showFullStockInfo}
                        disableItemReplacement={this.props.disableItemReplacement}
                    />
                })}
            </div>    
        }
    
    render() {
        const rowStyle = {
            paddingTop: "15px",
            paddingLeft: "15px",
            paddingBottom: "15px"
        }

        var size = this.props.item.imageFileName == 'no-image.svg' ? '40' : '';
        return <div key={this.props.item.stockcode} className="item">

            <div className="row" style={rowStyle} >
                <div className="col-2 col-md-1 col-lg-1 col-sm-1 d-none d-md-block">
                    <a href={this.props.item.url}><div className="list-group"> <img src={this.props.item.imageFileName} className="product-image" width={size} /> </div></a>
                        </div>
                           <div className="col-6 col-lg-6 col-sm-6">
                                <p className="description"><a href={this.props.item.url}>{this.props.item.name}</a></p>
                                <span className="stockcode">Code: {this.props.item.stockcode}</span>
                               <ProductApprovedStockListLogo product={this.props.item} />
                                {this.renderInStock()}
                                {this.renderShowAlternativesButton()}
                          </div>
                        <div className='col row item-row'>
                            {this.renderPrice()}
                            {this.renderEditCartOptions()}
                        </div>
                    </div>
            {this.renderShowAlternatives()}
               </div>;
    }

}

export const ProductRow = withCart(ProductRowRaw);
